import mixBar from "./mixbar/MixBar";
import lineChart from "./linechart/LineChart";
import pieChart from "./piechart/PieChart";

export const MixBar = mixBar;
export const LineChart = lineChart;
export const PieChart = pieChart;
